import { Outlet } from "react-router-dom"
import Error403 from "pages/Error403"

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from "data/data"

function AuthorityRoute ({ pageRole }) {
  const { role } = useEnumApi();
  

  if (pageRole && pageRole.length > 0) {
    if (pageRole.length === 1 && pageRole[0] === ROLE.ALL.code) {
      return <Outlet />;
    } else {
      if (pageRole.includes(role)) {
        return <Outlet />;
      } else {
        return <Error403 />;
      }
    }
  } else {
    return <Error403 />;
  }
}

export default AuthorityRoute